import { Configuration } from '@azure/msal-browser';

// Config object to be passed to Msal on creation

const clientId = import.meta.env.VITE_CLIENT_ID as string;
const authority = import.meta.env.VITE_AUTHORITY as string;
const redirectUri = import.meta.env.VITE_REDIRECT_URL as string;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority,
    knownAuthorities: ['arbordayb2c.b2clogin.com'],
    redirectUri,
    navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};
